import { vuexHandbook } from '@/store/composition/handbook'
import {
  ReclamationOuterReasonApi
} from '@/api/handbook/reclamation/ReclamationOuterReason/ReclamationOuterReasonApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: ReclamationOuterReasonApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
